// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"824d3086","455":"0d527cd2","977":"28e437ee"}[chunkId] + ".chunk.js";
};